import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../layout/header4";
import Footer from "../layout/footer";

const bg = require("../../images/banner/bnr1.jpg");

const BlogHalfImg = () => {
  const { t } = useTranslation();
  const historyTimeline = t("history.timeline", { returnObjects: true });

  return (
    <>
      <Helmet>
        <title>{t("history.meta.title")}</title>
        <meta name="description" content={t("history.meta.description")} />
        <meta name="keywords" content={t("history.meta.keywords")} />
        <meta name="author" content="Gargouri Emballages" />
        <meta property="og:title" content={t("history.meta.title")} />
        <meta
          property="og:description"
          content={t("history.meta.description")}
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.gargouri-emballages.com/historique"
        />
        <meta name="twitter:title" content={t("history.meta.title")} />
        <meta
          name="twitter:description"
          content={t("history.meta.description")}
        />
        <meta
          name="twitter:image"
          content="https://backend.gargouri-emballages.com/upload/products/images/img-Seau%20Rond%2030L-1746493801525-27qdce.jpg"
        />
      </Helmet>
      <Header />
      <div className="page-content bg-white">
        <div
          className="dlab-bnr-inr overlay-black-middle bg-pt"
          style={{ backgroundImage: `url(${bg})` }}
        >
          <div className="container">
            <div className="dlab-bnr-inr-entry">
              <h1 className="text-white">{t("history.title")}</h1>
              <div className="breadcrumb-row">
                <ul className="list-inline">
                  <li>
                    <Link to="/">{t("header.home")}</Link>
                  </li>
                  <li>{t("history.breadcrumb")}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="content-area">
          <div className="container">
            <div className="timeline-style1">
              {historyTimeline.map((item, index) => (
                <div className="timeline-item" key={index}>
                  <div className="timeline-year">{item.year}</div>
                  <div className="timeline-content">
                    <h4>{item.title}</h4>
                    {item.content.map((paragraph, pIndex) => (
                      <div key={pIndex} className="timeline-paragraph">
                        {paragraph.subtitle && (
                          <h5 className="timeline-subtitle">
                            {paragraph.subtitle}
                          </h5>
                        )}
                        <p>{paragraph.text}</p>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>{" "}
      {/* Closing the page-content div */}
      <Footer />
      <style jsx>{`
        .timeline-style1 {
          position: relative;
          max-width: 1200px;
          margin: 0 auto;
          padding: 40px 20px;
        }
        .timeline-item {
          display: flex;
          margin-bottom: 60px;
          position: relative;
        }
        .timeline-year {
          font-size: 28px;
          font-weight: 700;
          color: grey;
          min-width: 120px;
          padding-right: 30px;
          text-align: right;
        }
        .timeline-content {
          position: relative;
          padding-left: 30px;
          border-left: 3px solid grey;
          flex: 1;
        }
        .timeline-content::before {
          content: "";
          position: absolute;
          width: 16px;
          height: 16px;
          background: grey;
          border-radius: 50%;
          left: -9px;
          top: 8px;
        }
        .timeline-content h4 {
          color: #333;
          font-size: 22px;
          margin-bottom: 15px;
        }
        .timeline-paragraph {
          margin-bottom: 20px;
        }
        .timeline-subtitle {
          color: grey;
          font-size: 18px;
          margin: 15px 0 5px;
          font-weight: 600;
        }
        .timeline-content p {
          color: #666;
          line-height: 1.8;
          margin-bottom: 10px;
        }
        @media (max-width: 767px) {
          .timeline-item {
            flex-direction: column;
          }
          .timeline-year {
            text-align: left;
            padding-right: 0;
            margin-bottom: 15px;
          }
          .timeline-content {
            padding-left: 20px;
          }
        }
      `}</style>
    </>
  );
};

export default BlogHalfImg;
